<template>
  <div>
    <h2 align="center"> Зачетная книжка № {{ book_number }}</h2>
    <div v-if="width >= 1024 && height >= 768" class="ui two column very relaxed grid">
      <div class="column">
        <div class="ui items">
          <div class="item">
            <div class="image">
              <img :src="student.avatar_url" alt="Фото">
            </div>
            <div class="content">
              <a class="header">{{ student.surname }} {{ student.name }} {{ student.patronymic }} {{student.group[state] }}</a>
              <div class="meta">
                <span class="edu_level">{{ student.edu_level[state] }}</span>
                <span class="speciality_name">{{ student.speciality_name[state] }}</span>
              </div>
              <div class="extra">
                {{ student.facility[state] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column" align="right">
        <div class="ui horizontal segments">
          <div class="ui black inverted segment" :style="{width: '50%', height: '100%'}">
            <h2 class="ui header">
              {{ debt }}
              <div class="sub header" :style="{color: 'white'}">Количество задолжностей</div>
            </h2>
          </div>
          <div class="ui fade reveal" :style="{width: '50%', height: '100%'}">
            <div class="visible content" :style="{width: '100%', height: '100%'}">
              <div class="ui grey inverted segment" :style="{width: '100%', height: '100%'}">
                <h3 class="ui header" :style="{color: 'white', textAlign: 'center'}">
                  Качество диплома
                </h3>
              </div>
            </div>
            <div class="hidden content" :style="{width: '100%'}">
              <div v-if="dipType" class="ui red inverted segment" :style="{width: '100%'}">
                <h2 class="ui header" :style="{color: '#FFD700'}">
                  {{ Math.round(percent) }}%
                  <div class="sub header" :style="{color: '#FFD700'}">Диплом с отличием</div>
                </h2>
              </div>
              <div v-else class="ui blue inverted segment" :style="{width: '100%'}">
                <h2 class="ui header">
                  {{ Math.round(percent) }}%
                  <div class="sub header" :style="{color: 'white'}">Стандартный диплом</div>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="ui items">
        <div class="item">
          <div class="image">
            <img :src="student.avatar_url" alt="Фото">
          </div>
          <div class="content">
            <a class="header">{{ student.surname }} {{ student.name }} {{ student.patronymic }} {{ student.group[state] }}</a>
            <div class="meta">
              <span class="edu_level">{{ student.edu_level[state] }}</span>
              <span class="speciality_name">{{ student.speciality_name[state] }}</span>
            </div>
            <div class="extra">
              {{ student.facility[state] }}
            </div>
          </div>
        </div>
      </div>
      <div class="ui segments">
        <div class="ui black inverted segment">
          <h2 class="ui header">
            {{ debt }}
            <div class="sub header" :style="{color: 'white'}">Количество задолжностей</div>
          </h2>
        </div>
        <div class="ui fade reveal" :style="{width: '100%', height: '100%'}">
          <div class="visible content" :style="{width: '100%', height: '100%'}">
            <div class="ui grey inverted segment" :style="{width: '100%', height: '100%'}">
              <h3 class="ui header" :style="{color: 'white', textAlign: 'center'}">
                Качество диплома
              </h3>
            </div>
          </div>
          <div class="hidden content" :style="{width: '100%'}">
            <div v-if="dipType" class="ui red inverted segment" :style="{width: '100%'}">
              <h2 class="ui header" :style="{color: '#FFD700'}">
                {{ Math.round(percent) }}%
                <div class="sub header" :style="{color: '#FFD700'}">Диплом с отличием</div>
              </h2>
            </div>
            <div v-else class="ui blue inverted segment" :style="{width: '100%'}">
              <h2 class="ui header">
                {{ Math.round(percent) }}%
                <div class="sub header" :style="{color: 'white'}">Обычный диплом</div>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="errors.length" class="ui error message">
      <div class="header">
        Не возможно скачать зачетную книжку обратитесь пожалуйста в деканат
      </div>
      <ul class="list">
        <li v-for="error in errors">{{ error.subject }} {{ error.term }} <b>нет преподавтеля</b></li>
      </ul>
    </div>
    <div class="ui buttons" v-if="record_books > 1">
      <button class="ui positive button" v-on:click="changeState(0)">Зачетная книжка 1</button>
      <div class="or"></div>
      <button class="ui positive button" v-on:click="changeState(1)">Зачетная книжка 2</button>
    </div>
    <div class="ui stackable tabular menu">
      <a v-show="uniq.includes('Первый семестр')" class="item" data-tab="first">Первый курс</a>
      <a v-show="uniq.includes('Третий семестр')" class="item" data-tab="second">Второй курс</a>
      <a v-show="uniq.includes('Пятый семестр')" class="item" data-tab="third">Третий курс</a>
      <a v-show="uniq.includes('Седьмой семестр')" class="item" data-tab="fourth">Четвертый курс</a>
      <a v-show="uniq.includes('Девятый семестр')" class="item" data-tab="fifth">Пятый курс</a>
      <a v-show="uniq.includes('Одиннадцатый семестр')" class="item" data-tab="sixth">Шестой курс</a>
      <a v-show="uniq.includes('Первый год')" class="item" data-tab="first_year">Первый год</a>
      <a v-show="uniq.includes('Второй год')" class="item" data-tab="second_year">Второй год</a>
      <a v-show="uniq.includes('Третий год')" class="item" data-tab="third_year">Третий год</a>
      <a class="item" data-tab="elective">Факультативные дисциплины</a>
      <a class="item" data-tab="coursework">Курсовые работы(проекты)</a>
      <a class="item" data-tab="practice">Практика</a>
    </div>
    <div class="ui bottom attached tab segment" data-tab="first">
      <div class="ui top attached tabular menu two item">
        <a class="item" data-tab="first/1">1-й семестр</a>
        <a class="item" data-tab="first/2">2-й семестр</a>
      </div>
      <div class="ui bottom attached tab segment" data-tab="first/1">
        <study-year
            :control="control['Первый семестр']"
        ></study-year>
      </div>
      <div class="ui bottom attached tab segment" data-tab="first/2">
        <study-year
            :control="control['Второй семестр']"
        ></study-year>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="second">
      <div class="ui top attached tabular menu two item">
        <a class="active item" data-tab="second/3">3-й семестр</a>
        <a class="item" data-tab="second/4">4-й семестр</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="second/3">
        <study-year
            :control="control['Третий семестр']"
        ></study-year>
      </div>
      <div class="ui bottom attached tab segment" data-tab="second/4">
        <study-year
            :control="control['Четвертый семестр']"
        ></study-year>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="third">
      <div class="ui top attached tabular menu two item">
        <a class="active item" data-tab="third/5">5-й семестр</a>
        <a class="item" data-tab="third/6">6-й семестр</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="third/5">
        <study-year
            :control="control['Пятый семестр']"
        ></study-year>
      </div>
      <div class="ui bottom attached tab segment" data-tab="third/6">
        <study-year
            :control="control['Шестой семестр']"
        ></study-year>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="fourth">
      <div class="ui top attached tabular menu two item">
        <a class="active item" data-tab="fourth/7">7-й семестр</a>
        <a class="item" data-tab="fourth/8">8-й семестр</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="fourth/7">
        <study-year
            :control="control['Седьмой семестр']"
        ></study-year>
      </div>
      <div class="ui bottom attached tab segment" data-tab="fourth/8">
        <study-year
            :control="control['Восьмой семестр']"
        ></study-year>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="fifth">
      <div class="ui top attached tabular menu two item">
        <a class="active item" data-tab="fifth/9">9-й семестр</a>
        <a class="item" data-tab="fifth/10">10-й семестр</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="fifth/9">
        <study-year
            :control="control['Девятый семестр']"
        ></study-year>
      </div>
      <div class="ui bottom attached tab segment" data-tab="fifth/10">
        <study-year
            :control="control['Десятый семестр']"
        ></study-year>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="sixth">
      <div class="ui top attached tabular menu two item">
        <a class="active item" data-tab="sixth/11">11-й семестр</a>
        <a class="item" data-tab="sixth/12">12-й семестр</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="sixth/11">
        <study-year
            :control="control['Одиннадцатый семестр']"
        ></study-year>
      </div>
      <div class="ui bottom attached tab segment" data-tab="sixth/12">
        <study-year
            :control="control['Двенадцатый семестр']"
        ></study-year>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="first_year">
      <study-year
          :control="control['Первый год']"
      ></study-year>
    </div>
    <div class="ui bottom attached tab segment" data-tab="second_year">
      <study-year
          :control="control['Второй год']"
      ></study-year>
    </div>
    <div class="ui bottom attached tab segment" data-tab="third_year">
      <study-year
          :control="control['Третий год']"
      ></study-year>
    </div>
    <div class="ui bottom attached tab segment" data-tab="elective">
      <study-year
          :control="control.Факультативы"
      ></study-year>
    </div>
    <div class="ui bottom attached tab segment" data-tab="coursework">
      <table class="ui basic celled table">
        <thead>
        <tr class="active">
          <th></th>
          <th>Дисциплина</th>
          <th>Тема курсовой работы (проекта)</th>
          <th>Семестр</th>
          <th>Оценка</th>
          <th>Дата сдачи</th>
          <th>Фамилия преподавателя</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="record in coursework"
            :style="record.mark === 'Неудовлетворительно' || record.mark === 'Не явился' ? 'background-color:red' : 'background-color:none'">
          <td width="1%"></td>
          <td width="20%">{{ record.name }}</td>
          <td width="35%">{{ record.theme }}</td>
          <td width="7%">{{ record.term }}</td>
          <td width="5%">{{ record.mark }}</td>
          <td width="9%">{{ record.date }}</td>
          <td width="23%">{{ record.teacher }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="ui bottom attached tab segment" data-tab="practice">
      <table class="ui basic celled table">
        <thead>
        <tr class="active">
          <th></th>
          <th>Наименование вида практики</th>
          <th>Семестр</th>
          <th>Место проведения практики</th>
          <th>В качестве кого работал (должность)</th>
          <th>Ф.И.О. руководителя практики от предприятия</th>
          <th>Часы</th>
          <th>Фамилия преподавателя</th>
          <th>Оценка</th>
          <th>Дата сдачи</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="record in practice"
            :style="record.mark === 'Неудовлетворительно' || record.mark === 'Не явился' ? 'background-color:red' : 'background-color:none'">
          <td width="1%"></td>
          <td width="20%">{{ record.name }}</td>
          <td width="7%">{{ record.term }}</td>
          <td width="10%">{{ record.organization }}</td>
          <td width="13%">{{ record.position }}</td>
          <td width="15%">{{ record.leader }}</td>
          <td width="5%">{{ record.hours }}</td>
          <td width="15%">{{ record.teacher }}</td>
          <td width="5%">{{ record.mark }}</td>
          <td width="9%">{{ record.date }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <button class="ui primary button" @click="MakePDF">Скачать</button>
  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios'
import StudyYear from "./record_book/study_year.vue";
import record_boock_pdf from "../../makepdfs/record_book/record_boock_pdf";

export default {
  name: "record_book_view",
  components: {
    StudyYear,
  },
  data: () => ({
    periods: [],
    types: [],
    errors: [],
    records: [],
    student: {
      name: '',
      surname: '',
      patronymic: '',
      avatar_url: '',
      edu_level: [],
      speciality_name: [],
      facility: [],
      decan: [],
      group: [],
      record_books: [],
    },
    state: 0,
    percent: 0,
    debt: 0,
    book_number: "",
    control: {
      'Первый семестр': {exam: [], test: []},
      'Второй семестр': {exam: [], test: []},
      'Третий семестр': {exam: [], test: []},
      'Четвертый семестр': {exam: [], test: []},
      'Пятый семестр': {exam: [], test: []},
      'Шестой семестр': {exam: [], test: []},
      'Седьмой семестр': {exam: [], test: []},
      'Восьмой семестр': {exam: [], test: []},
      'Девятый семестр': {exam: [], test: []},
      'Десятый семестр': {exam: [], test: []},
      'Одиннадцатый семестр': {exam: [], test: []},
      'Двенадцатый семестр': {exam: [], test: []},
      'Факультативы': {exam: [], test: []},
      'Первый год': {exam: [], test: []},
      'Второй год': {exam: [], test: []},
      'Третий год': {exam: [], test: []},
    },
    coursework: [],
    practice: [],
    record_books: 0,
  }),

  computed: {
    uniq: function () {
      this.records.forEach(record => {
        if (record.term !== null)
          this.periods.push(record.term)
      })
      return [...new Set(this.periods)]
    },

    dipType: function () {
      this.debt = 0
      this.percent = 0
      let great = 0
      let all = 0
      let sat = 0
      let bad = 0
      let honour = false
      this.records.forEach(record => {
        this.book_number = record.stud_rec_book
        if (record.mark !== null)
          if (record.teacher === null) {
            this.errors.push(record)
          }
        if (record.mark === 'Отлично') {
          great += 1
          all += 1
        } else if (record.mark === 'Удовлетворительно') {
          sat += 1
          all += 1
        } else if (record.mark === 'Неудовлетворительно' || record.mark === 'Не явился') {
          bad += 1
          all += 1
        } else if (record.mark === 'Хорошо') {
          all += 1
        } else if (record.mark === 'Не зачтено') {
          bad += 1
        }
      })
      this.debt = bad
      this.percent = great / all * 100
      if (bad === 0 && sat === 0 && this.percent > 75)
        honour = true
      return honour
    },
    height: function () {
      return $(window).height();
    },
    width: function () {
      return $(window).width();
    }
  },

  methods: {
    getRecord(id) {
      axios({
        method: 'get',
        url: `/study/${id}/record_book.json`,
      }).then((response) => {
        this.records = response.data.records;
        let unique = _.uniqWith(this.records, _.isEqual);
        this.records = unique
        this.getExams()
      }).catch((error) => {
        return error;
      });
    },

    getStudent() {
      axios({
        method: 'get',
        url: '/study/student',
      }).then((response) => {
        this.student = response.data.student;
        this.getRecord(this.student.record_books[0])
        this.record_books = this.student.record_books.length
      }).catch((error) => {
        return error;
      });
    },

    getExams() {
      this.control = {
        'Первый семестр': {exam: [], test: []},
        'Второй семестр': {exam: [], test: []},
        'Третий семестр': {exam: [], test: []},
        'Четвертый семестр': {exam: [], test: []},
        'Пятый семестр': {exam: [], test: []},
        'Шестой семестр': {exam: [], test: []},
        'Седьмой семестр': {exam: [], test: []},
        'Восьмой семестр': {exam: [], test: []},
        'Девятый семестр': {exam: [], test: []},
        'Десятый семестр': {exam: [], test: []},
        'Одиннадцатый семестр': {exam: [], test: []},
        'Двенадцатый семестр': {exam: [], test: []},
        'Факультативы': {exam: [], test: []},
        'Первый год': {exam: [], test: []},
        'Второй год': {exam: [], test: []},
        'Третий год': {exam: [], test: []},
      }
      this.coursework = []
      this.practice = []
      let count_exe = 1
      let count_tee = 1
      let count_cw = 1
      let count_pr = 1
      Object.entries(this.control).forEach(entry => {
        let count_ex = 1
        let count_te = 1
        const [key, value] = entry;
        _.filter(this.records, {term: key}).forEach(record => {
          if ((/Б2.*/.test(record.block) || record.block === 'ПМ' || record.block === 'ПДП' || (/ПМ.*/).test(record.block) || (/[а-яА-Я]+.ПМ/).test(record.block)) && record.mark !== null) {
            let position = " ";
            let organization = " ";
            let leader = " ";
            if (record.stud_position !== null)
              position = record.stud_position;
            if (record.organization !== null)
              organization = record.organization;
            if (record.teach_leader !== null)
              leader = record.organization;
            let prac = {
              num: count_pr,
              name: record.subject,
              term: record.term,
              organization: organization,
              position: position,
              leader: leader,
              hours: `${record.total_load}/${record.credits}`,
              mark: record.mark,
              date: `${('0' + new Date(record.date).getDate()).slice(-2)}.${('0' + (new Date(record.date).getMonth() + 1)).slice(-2)}.${new Date(record.date).getFullYear()}`,
              teacher: record.teacher
            };
            count_pr = count_pr + 1;
            this.practice.push(prac);
          } else if (record.mark !== null && (record.type_of_the_control === 'Экзамен' || record.type_of_the_control === 'Экзамен квалификационный (СПО)' || record.type_of_the_control === 'Экзамен (СПО)')) {
            let exam = {
              num: count_ex,
              name: record.subject,
              hours: `${record.total_load}/${record.credits}`,
              mark: record.mark,
              date: `${('0' + new Date(record.date).getDate()).slice(-2)}.${('0' + (new Date(record.date).getMonth() + 1)).slice(-2)}.${new Date(record.date).getFullYear()}`,
              teacher: record.teacher
            };
            count_ex = count_ex + 1;
            value.exam.push(exam)
          } else if (record.mark !== null && (record.type_of_the_control === 'Зачет' || record.type_of_the_control === 'Зачет с оценкой' || record.type_of_the_control === 'Дифференцированный зачет (СПО)' || record.type_of_the_control === 'Зачет (СПО)' || record.type_of_the_control === 'Другие формы контроля (СПО)') && record.block !== 'ПМ' && record.block !== 'ПДП' && !(/ПМ.*/).test(record.block) && !(/[а-яА-Я]+.ПМ/).test(record.block)) {
            let test = {
              num: count_te,
              name: record.subject,
              hours: `${record.total_load}/${record.credits}`,
              mark: record.mark,
              date: `${('0' + new Date(record.date).getDate()).slice(-2)}.${('0' + (new Date(record.date).getMonth() + 1)).slice(-2)}.${new Date(record.date).getFullYear()}`,
              teacher: record.teacher
            };
            count_te = count_te + 1;
            value.test.push(test);
          } else if ((record.type_of_the_control === 'Курсовая работа' || record.type_of_the_control === 'Курсовой проект (СПО)' || record.type_of_the_control === 'Курсовая работа (СПО)' || record.type_of_the_control === 'Курсовой проект') && record.mark !== null) {
            let theme = " ";
            if (record.theme !== null)
              theme = record.theme;
            let exam = {
              num: count_cw,
              name: record.subject,
              theme: theme,
              term: record.term,
              mark: record.mark,
              date: `${('0' + new Date(record.date).getDate()).slice(-2)}.${('0' + (new Date(record.date).getMonth() + 1)).slice(-2)}.${new Date(record.date).getFullYear()}`,
              teacher: record.teacher
            }
            count_cw = count_cw + 1;
            this.coursework.push(exam);
          }
          if ((/ФТД.*/).test(record.block) && (record.type_of_the_control === 'Экзамен') && record.mark !== null) {
            let exam = {
              num: count_exe,
              name: record.subject,
              hours: `${record.total_load}/${record.credits}`,
              mark: record.mark,
              date: `${('0' + new Date(record.date).getDate()).slice(-2)}.${('0' + (new Date(record.date).getMonth() + 1)).slice(-2)}.${new Date(record.date).getFullYear()}`,
              teacher: record.teacher
            };
            count_exe = count_exe + 1;
            this.control.Факультативы.exam.push(exam);
          } else if ((/ФТД.*/).test(record.block) && (record.type_of_the_control === 'Зачет' || record.type_of_the_control === 'Зачет с оценкой') && record.mark !== null) {
            let test = {
              num: count_tee,
              name: record.subject,
              hours: `${record.total_load}/${record.credits}`,
              mark: record.mark,
              date: `${('0' + new Date(record.date).getDate()).slice(-2)}.${('0' + (new Date(record.date).getMonth() + 1)).slice(-2)}.${new Date(record.date).getFullYear()}`,
              teacher: record.teacher
            };
            count_tee = count_tee + 1;
            this.control.Факультативы.test.push(test);
          }
        })
      })
    },

    changeState(num) {
      this.state = num;
      this.getRecord(this.state)
    },

    MakePDF() {
      record_boock_pdf.MakePDF(this.student, this.control, this.coursework, this.practice, this.book_number, this.state)
    },
  },

    mounted() {
      this.getStudent()
    }
  }

</script>

<style>

</style>